import { CloseCircle } from "iconsax-react";
import React from "react";
import { Link } from "react-router-dom";

export const NoAccessInfo = ({ msg, isRemovable }) => {
  return (
    <div
      className={`flex justify-between items-center bg-primary-lighter border border-primary py-4 px-5 rounded-md my-5`}
    >
      {isRemovable ? (
        <div className="flex gap-x-4">
          <button
            onClick={onClose}
            className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <CloseCircle className="h-6 w-6" />
          </button>
          <span className="text-sm">{msg}</span>
        </div>
      ) : (
        <span className="text-sm">{msg}</span>
      )}
      <Link
        to="/dashboard/billing"
        className="bg-primary min-h-[35px] w-[150px] flex justify-center items-center text-center px-3 py-2 rounded-md text-white hover:bg-teal-700 transition duration-300 text-sm"
      >
        Upgrade Plan
      </Link>
    </div>
  );
};
